@if (environment) {
  <div
    id="topbar"
    class="d-print-none">
    <div class="{{ environment }}"></div>
  </div>
}
<div class="page-container">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  @if (router !== '/accessibilitystatement') {
    <wfp-footer class="d-print-none"></wfp-footer>
  }
</div>
